import {throttle} from 'lodash';
import {useCallback, useEffect, useRef, useState} from 'react';
import {MAP_LAYER_Z_INDEX} from '@/map/constants';
import {Marker} from '@/map/modules';
import {CursorTextContent, IContentProps} from './CursorTextContent';

type ILatLng = naver.maps.LatLng;

interface IProps extends IContentProps {
  map: naver.maps.Map;
  onPointed?(point: ILatLng): void;
}

export const DrawStartCursor = ({map, onPointed, ...props}: IProps) => {
  const evt = useRef<naver.maps.MapEventListener[]>([]);
  const [position, setPosition] = useState<ILatLng | undefined>();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const onMousemoveEvent = useCallback(
    throttle((e: {coord: ILatLng}) => {
      setPosition(e.coord);
    }, 50),
    [setPosition]
  );

  useEffect(() => {
    evt.current.push(
      naver.maps.Event.addListener(map, 'mousemove', onMousemoveEvent)
    );

    evt.current.push(
      naver.maps.Event.addListener(map, 'mousedown', (e: {coord: ILatLng}) =>
        onPointed?.(e.coord)
      )
    );

    return () => {
      if (evt?.current) {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        evt.current.map((event) => naver.maps.Event.removeListener(event));
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [map]);

  if (!position) {
    return null;
  }

  return (
    <Marker
      map={map}
      position={position}
      draggable={false}
      clickable={false}
      zIndex={MAP_LAYER_Z_INDEX.MAP_CURSOR}
    >
      <CursorTextContent {...props} />
    </Marker>
  );
};
